import React from 'react';

export type BillingPeriod = 'monthly' | 'yearly';

interface BillingPeriodToggleProps {
  value: BillingPeriod;
  onChange: (v: BillingPeriod) => void;
  language?: 'en' | 'zh';
  isDarkMode?: boolean;
}

const BillingPeriodToggle: React.FC<BillingPeriodToggleProps> = ({
  value,
  onChange,
  language = 'zh',
  isDarkMode = true,
}) => {
  const isEn = language === 'en';
  const label = (zh: string, en: string) => (isEn ? en : zh);

  const wrapStyle = isDarkMode
    ? 'border border-white/15 bg-white/[0.04]'
    : 'border border-black/10 bg-black/[0.03]';

  const activeStyle = isDarkMode
    ? 'bg-white text-zinc-900 shadow-sm'
    : 'bg-zinc-900 text-white shadow-sm';

  const idleStyle = isDarkMode
    ? 'text-white/55 hover:text-white/85 hover:bg-white/[0.06]'
    : 'text-zinc-500 hover:text-zinc-800 hover:bg-black/[0.04]';

  return (
    <div
      className={`inline-flex rounded-lg p-0.5 gap-0.5 shrink-0 ${wrapStyle}`}
      role="tablist"
      aria-label={label('计费周期', 'Billing period')}
    >
      <button
        type="button"
        role="tab"
        aria-selected={value === 'monthly'}
        className={`rounded-md px-3.5 py-1.5 text-[13px] font-semibold transition-colors ${
          value === 'monthly' ? activeStyle : idleStyle
        }`}
        onClick={() => onChange('monthly')}
      >
        {label('月度', 'Monthly')}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === 'yearly'}
        className={`rounded-md px-3.5 py-1.5 text-[13px] font-semibold transition-colors ${
          value === 'yearly' ? activeStyle : idleStyle
        }`}
        onClick={() => onChange('yearly')}
      >
        {label('半年度', 'Semi-annual')}
      </button>
    </div>
  );
};

export default BillingPeriodToggle;
